import {
  forwardRef,
  Component,
  Input,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector     : 'nz-progress',
  encapsulation: ViewEncapsulation.None,
  template     : `
    <div [ngClass]="'ant-progress ant-progress-status-'+nzStatus"
      [class.ant-progress-line]="nzType=='line'"
      [class.ant-progress-show-info]="nzShowInfo"
      [class.ant-progress-circle]="nzType=='circle'">
      <div *ngIf="nzType=='line'">
        <div class="ant-progress-outer"><!----><div class="ant-progress-inner"><!----><div class="ant-progress-bg" [style.width.%]="_percent" [style.height.px]="nzStrokeWidth"></div><!----></div><!----></div><!----><span class="ant-progress-text" *ngIf="nzShowInfo"><ng-template [ngIf]="(nzStatus=='active')||(nzStatus=='normal')||(_hasFormat)">{{ _format(_percent) }}</ng-template><ng-template [ngIf]="(nzStatus=='exception')||(nzStatus=='success')&&(!_hasFormat)"><i class="anticon" [ngClass]="{'anticon-check-circle':nzStatus=='success','anticon-cross-circle':nzStatus=='exception'}"></i></ng-template></span>
      </div>
      <div class="ant-progress-inner" *ngIf="nzType=='circle'" [ngStyle]="_circleStyle">
        <svg class="rc-progress-circle " viewBox="0 0 100 100" *ngIf="nzType=='circle'">
          <path class="rc-progress-circle-trail" [attr.d]="_pathString" stroke="#f3f3f3" [attr.stroke-width]="nzStrokeWidth" fill-opacity="0"></path>
          <path class="rc-progress-circle-path" [attr.d]="_pathString" stroke-linecap="round" [attr.stroke]="_statusColorMap[nzStatus]" stroke-width="6" fill-opacity="0" [ngStyle]="_pathStyle"></path>
        </svg>
        <span class="ant-progress-text" *ngIf="nzShowInfo"><ng-template [ngIf]="(nzStatus=='active')||(nzStatus=='normal')||(_hasFormat)">{{ _format(_percent) }}</ng-template><ng-template [ngIf]="(nzStatus=='exception')||(nzStatus=='success')&&!(_hasFormat)"><i class="anticon" [ngClass]="{'anticon-check':nzStatus=='success','anticon-cross':nzStatus=='exception'}"></i></ng-template></span>
      </div>
    </div>
  `,
  providers    : [
    {
      provide    : NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NzProgressComponent),
      multi      : true
    }
  ],
  styles: [
    `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable declaration-bang-space-before */
/* stylelint-disable declaration-bang-space-before */
.ant-progress {
  display: inline-block;
}
.ant-progress-line {
  width: 100%;
  font-size: 14px;
  position: relative;
}
.ant-progress-outer {
  display: inline-block;
  width: 100%;
  margin-right: 0;
  padding-right: 0;
}
.ant-progress-show-info .ant-progress-outer {
  padding-right: 2.75em;
  margin-right: -2.75em;
}
.ant-progress-inner {
  display: inline-block;
  width: 100%;
  background-color: #f7f7f7;
  border-radius: 100px;
  vertical-align: middle;
}
.ant-progress-circle-trail {
  stroke: #f7f7f7;
}
.ant-progress-circle-path {
  stroke: #00b8a9;
}
.ant-progress-bg {
  border-radius: 100px;
  background-color: #00b8a9;
  transition: all 0.4s cubic-bezier(0.08, 0.82, 0.17, 1) 0s;
  position: relative;
}
.ant-progress-text {
  width: 2em;
  text-align: left;
  font-size: 1em;
  margin-left: 0.75em;
  vertical-align: middle;
  display: inline-block;
}
.ant-progress-text .anticon {
  font-size: 14px;
}
.ant-progress-status-active .ant-progress-bg:before {
  content: "";
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  border-radius: 10px;
  animation: ant-progress-active 2.4s cubic-bezier(0.23, 1, 0.32, 1) infinite;
}
.ant-progress-status-exception .ant-progress-bg {
  background-color: #f04134;
}
.ant-progress-status-exception .ant-progress-text {
  color: #f04134;
}
.ant-progress-status-exception .ant-progress-circle-path {
  stroke: #f04134;
}
.ant-progress-status-success .ant-progress-bg {
  background-color: #00a854;
}
.ant-progress-status-success .ant-progress-text {
  color: #00a854;
}
.ant-progress-status-success .ant-progress-circle-path {
  stroke: #00a854;
}
.ant-progress-circle .ant-progress-inner {
  position: relative;
  line-height: 1;
  background-color: transparent;
}
.ant-progress-circle .ant-progress-text {
  display: block;
  position: absolute;
  width: 100%;
  text-align: center;
  line-height: 1;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  font-family: tahoma;
  margin: 0;
}
.ant-progress-circle .ant-progress-text .anticon {
  font-size: 1.16666667em;
}
.ant-progress-circle .ant-progress-status-exception .ant-progress-text {
  color: #f04134;
}
.ant-progress-circle .ant-progress-status-success .ant-progress-text {
  color: #00a854;
}
@keyframes ant-progress-active {
  0% {
    opacity: 0.1;
    width: 0;
  }
  20% {
    opacity: 0.5;
    width: 0;
  }
  100% {
    opacity: 0;
    width: 100%;
  }
}
`
  ]
})
export class NzProgressComponent implements ControlValueAccessor, OnInit {
  _statusColorMap = {
    normal   : '#108ee9',
    exception: '#ff5500',
    success  : '#87d068',
  };

  _pathString = '';
  _pathStyle = {};
  _circleStyle = {};
  _percent = 0;
  _hasFormat = false;
  _rawStatus = 'normal';
  // ngModel Access
  onChange: (value: number) => void = () => null;
  onTouched: () => void = () => null;

  @Input() nzType = 'line';
  @Input() nzStrokeWidth: number = this.nzType === 'line' ? 10 : 6;
  @Input() nzWidth = 132;
  @Input() nzShowInfo = true;
  @Input() nzStatus = 'normal';

  @Input('nzFormat')
  set _setFormat(value: (input: number) => string) {
    this._format = value;
    this._hasFormat = true;
  }

  _format = (percent: number) => percent + '%';

  updateCircleStatus(): void {
    const circleSize = this.nzWidth || 132;
    this._circleStyle = {
      'width.px'    : circleSize,
      'height.px'   : circleSize,
      'font-size.px': circleSize * 0.16 + 6,
    };
    const radius = 50 - this.nzStrokeWidth / 2;
    const len = Math.PI * 2 * radius;
    this._pathString = `M 50,50 m 0,-${radius}\n     a ${radius},${radius} 0 1 1 0,${radius * 2}\n     a ${radius},${radius} 0 1 1 0,-${radius * 2}`;
    this._pathStyle = {
      'stroke-dasharray' : `${len}px ${len}px`,
      'stroke-dashoffset': (100 - this._percent) / 100 * len + 'px',
      'transition'       : 'stroke-dashoffset 0.3s ease 0s, stroke 0.3s ease'
    };
  }

  writeValue(value: number): void {
    this._percent = value;
    if (this._percent === 100) {
      this.nzStatus = 'success';
    } else {
      this.nzStatus = this._rawStatus;
    }
    if (this.nzType === 'circle') {
      this.updateCircleStatus();
    }
  }

  registerOnChange(fn: (_: number) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  ngOnInit(): void {
    this._rawStatus = this.nzStatus;
  }

}
